import React, { useEffect, useState, RefObject } from 'react';
import { useDeviceType } from '@/hooks';

/**
 * 自定义Hook：通过触摸滑动超过一定阈值时收起键盘，或者滚动到顶部/底部时直接触发
 * @param {RefObject<HTMLElement>} ref - 绑定监听事件的元素的ref
 * @param {number} threshold - 触发收起键盘的滑动阈值，默认为20
 */
const useHideKeyboardOnScroll = (ref: RefObject<HTMLElement>, threshold: number = 20) => {

  const { isMobile } = useDeviceType();

  const [startTouchY, setStartTouchY] = useState<number | null>(null);

  useEffect(() => {
    const element = ref.current;
    if (!element || !isMobile) return;

    const handleTouchStart = (e: TouchEvent) => {
      setStartTouchY(e.touches[0].clientY);
    };

    const handleTouchMove = (e: TouchEvent) => {
      if (startTouchY === null) return; // 如果没有开始触摸的Y坐标，就返回

      const currentTouchY = e.touches[0].clientY;
      const moveDistance = startTouchY - currentTouchY;

      if (Math.abs(moveDistance) > threshold) {
        const activeElement = document.activeElement as HTMLElement;
        if (activeElement && ['INPUT', 'TEXTAREA'].includes(activeElement.tagName)) {
          activeElement.blur();
        }
        // 重置开始触摸的Y坐标为null，防止重复触发
        setStartTouchY(null);
      }
    };

    element.addEventListener('touchstart', handleTouchStart);
    element.addEventListener('touchmove', handleTouchMove);

    return () => {
      element.removeEventListener('touchstart', handleTouchStart);
      element.removeEventListener('touchmove', handleTouchMove);
    };
  }, [ref, startTouchY, threshold, isMobile]);

};

export default useHideKeyboardOnScroll;